import { render } from "./CreateWordList.vue?vue&type=template&id=33b9002e&scoped=true"
import script from "./CreateWordList.vue?vue&type=script&lang=ts"
export * from "./CreateWordList.vue?vue&type=script&lang=ts"

import "./CreateWordList.vue?vue&type=style&index=0&id=33b9002e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33b9002e"

export default script